import { render } from "./ContactComponent.vue?vue&type=template&id=54c97d8e&ts=true"
import script from "./ContactComponent?vue&type=script&lang=ts"
export * from "./ContactComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__